import gql from 'graphql-tag';

export const DEAL_SMS_ACTIVITY_FRAGMENT = gql`
  fragment DealSmsActivityFields on DealSmsActivityViewModel {
    id
    type
    parentId
    updatedDateTime
    createdDateTime
    directionType
    message
    smsDirection
    status
    twilioMessageId
    twilioConversationSid
    conversationSequenceNumber
    createdByUserProfileId
    ownerPgCreditApplicationId
    isAgent
    demoMode
    endingMessage

    ownerPgCreditApplication {
      firstName
      lastName
      title
      phone
      pc
    }

    createdByUserProfile {
      firstName
      lastName
      title
      phoneNumber
    }
  }
`;
